import { Action } from '@ngrx/store';

export enum ActionTypes {
  INFO = '[Event Log] Info',
  SUCCESS = '[Event Log] Success',
  WARNING = '[Event Log] Warning',
  ERROR = '[Event Log] Error',
  EMPTY_ACTION = '[Event Log] Empty',
  CLEAR = '[Event Log] Clear',
}

export class Info implements Action {
  readonly type = ActionTypes.INFO;
  constructor(public payload: string | { alert: string; message: string }) {}
}

export class Success implements Action {
  readonly type = ActionTypes.SUCCESS;
  constructor(public payload: string | { alert: string; message: string }) {}
}

export class Warning implements Action {
  readonly type = ActionTypes.WARNING;
  constructor(public payload: string | { alert: string; message: string }) {}
}

export class Error implements Action {
  readonly type = ActionTypes.ERROR;
  constructor(public payload: string | { alert: string; message: string }) {}
}

export class EmptyAction implements Action {
  readonly type = ActionTypes.EMPTY_ACTION;
}

export class Clear implements Action {
  readonly type = ActionTypes.CLEAR;
}

export type Actions = Info | Success | Warning | Error | EmptyAction | Clear;
